<div class="floatLabel inputPrincipal" [ngClass]="{'soloLectura' : disabled}" style="position: relative">

  <!-- Input -->
  <input class="form-control" id="fechaCustom{{id}}" [(ngModel)]="fecha" [ngClass]="{'is-filled':datePickerControl.value, 'inputDeshabilitado' : disabled}" required #datePickerControl angular-mydatepicker (focusout)="Validar(datePickerControl.value)"
         (click)="dp.toggleCalendar(); touched = true"  #dp="angular-mydatepicker" [locale]="translate.getDefaultLang()" (ngModelChange)="NuevaFecha()" #inputCalendario 
         [options]="configuracion ? configuracion : {dateFormat: ('FormatoFechaCalendario' | translate), showTodayBtn: false, firstDayOfWeek: 'su', openSelectorOnInputClick: true, dateRange: rangoFecha, focusInputOnDateSelect:false}"  name="fechaEvento{{id}}">

  <!-- Título -->
  <label>{{titulo}}</label>

  <!-- Button limpiar --->
  <button *ngIf="datePickerControl.value && !disabled" (click)="LimpiarValor(); dp.toggleCalendar(); datePickerControl.value=''"
          class="buttonLimpiarFecha btnTimes">
    <span class="fa fa-times"></span>
  </button>

  <!-- Mensaje de error -->
  <span [hidden]="!verError || dp.isDateValid() || (!touched && !errorActivo)" class="textoError" >
    {{(mensajeError ? mensajeError : 'DatoIncompeto') | translate}}
  </span>

</div>
